(() => {
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ib-finish]');
    if (!button) return;
    const card = button.closest('.product-card-wrapper');
    if (!card) return;
    event.preventDefault();
    card.querySelectorAll('[data-ib-finish]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
    card.querySelectorAll('a[href*="/products/"]').forEach(a => a.href = button.dataset.url);
    card.querySelectorAll('[data-product-url]').forEach(b => b.dataset.productUrl = button.dataset.url);
    let price = card.querySelector('.ib-selected-price');
    if (!price) { price = document.createElement('div'); price.className = 'ib-selected-price'; card.querySelector('.card-information').append(price); }
    price.textContent = button.dataset.price;
    card.classList.add('ib-has-selected-finish');
    const img = card.querySelector('.card__media img');
    if (img) {
      if (!img.dataset.ibOriginalSrc) { img.dataset.ibOriginalSrc = img.src; img.dataset.ibOriginalSrcset = img.srcset; img.dataset.ibOriginalAlt = img.alt; }
      img.src = button.dataset.image || img.dataset.ibOriginalSrc;
      img.srcset = button.dataset.image ? '' : img.dataset.ibOriginalSrcset;
      img.alt = button.dataset.image ? `${img.dataset.ibOriginalAlt} — ${button.dataset.label}` : img.dataset.ibOriginalAlt;
      card.classList.toggle('ib-has-selected-image', Boolean(button.dataset.image));
    }
    const status = card.querySelector('.ib-card-finish-status');
    status.textContent = `${button.dataset.label}${button.dataset.available === 'false' ? ' · Sold out' : ''}${!button.dataset.image ? ' · Original finish pictured' : ''}`;
  });
  // Reveal only when a section enters view; content remains visible without JavaScript.
  if (!matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('ib-reveal'); observer.unobserve(entry.target); }
    }), { threshold: .12 });
    const observe = (scope = document) => scope.querySelectorAll('.ib-accessories__grid article,.ib-quality-note,.ib-campaign-pair,.ib-pairings .ib-shop-section-heading,.ib-editorial').forEach(el => observer.observe(el));
    observe(); document.addEventListener('shopify:section:load', event => observe(event.target));
  }
})();
